export const FILTER_FIELDS = [
  { name: 'firstName' as const, label: 'COMMON:FIRST_NAME' },
  { name: 'lastName' as const, label: 'COMMON:LAST_NAME' },
  { name: 'email' as const, label: 'COMMON:EMAIL' },
];

export type UsersSearchFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  customerId: string;
};

export const EMPTY_FILTERS: UsersSearchFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  customerId: '',
};
